export default __webpack_public_path__ + "static/media/ic-sort-black-24-px-closed.801cad01.svg";